<template>
    <transition name="fade">
        <div ref="popup" class="popup_info" v-show="showPopup">
            <div class="popup">
                <slot></slot>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props:{
        showPopup:{
            type: Boolean
        }
    },
    data(){
        return{
           
        }
    },
    mounted(){
        
    },
    watch:{
        showPopup(newValue, old){
            if(newValue){
                setTimeout(()=>{
                    this.$emit('update', false);
                },2000)
            }
        }
    }
}
</script>

<style scoped>
.popup_info{
    position: fixed;
    width: 100%;
    display: flex;
    justify-content: center;
    z-index: 999;
    left: 0;
    top: 60px;
}

.popup_info .popup{
    background: #2a2a2af2;
    padding: 10px 20px 10px 20px;
    border-radius: 8px;
    border: 1px solid #5555555e;
    /* backdrop-filter: blur(3px); */
    transition: .3s;
}

.fade-enter-active, .fade-leave-active {
  transition: .8s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    /* backdrop-filter: blur(0px); */
    opacity: 0;
  
}

@media only screen and (max-width: 768px) {
    .popup_info{
        bottom: 20px;
        top: auto;
    }
}
</style>